import React from "react";


export const LoadingPlaid = (props) => {
    return (
        <div>
            <p>Loading your data from Plaid...</p>
        </div>
    )
};